module.exports = __webpack_public_path__ + "img/DeliveryUniversal.11415816.png";